export default __webpack_public_path__ + "static/media/Avatar-10-noback.cd174f9f.png";